const createTheme = (theme) => theme;
export {
  createTheme
};
